<template>
  <p-calendar
    :date-format="DATEFORMAT"
    @keydown="onKeyDown"
    showButtonBar
    v-model="value"
  />
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';

import {
  DATEFORMAT,
  dateFormatter,
} from '@/stores/definitions';

const KEY_LEFT = 'ArrowLeft';
const KEY_UP = 'ArrowUp';
const KEY_RIGHT = 'ArrowRight';
const KEY_DOWN = 'ArrowDown';
const KEY_PAGE_UP = 'PageUp';
const KEY_PAGE_DOWN = 'PageDown';
const KEY_PAGE_HOME = 'Home';
const KEY_PAGE_END = 'End';

type GridDatePickerParams = { value?: string | Date | null };

export default defineComponent({
  props: {
    params: {
      type: Object as PropType<GridDatePickerParams>,
      default: () => ({}),
    }
  },
  data() {
    return {
      value: null as Date | null,
      DATEFORMAT,
    };
  },
  mounted() {
    this.value = this.params.value ? new Date(this.params.value) : new Date();
  },
  methods: {
    /* Component Editor Lifecycle method */
    getValue() {
      return this.value && dateFormatter(this.value).date || null;
    },
    onKeyDown(event: KeyboardEvent) {
      const { key } = event;

      const isNavigationKey = key === KEY_LEFT ||
      key === KEY_RIGHT ||
      key === KEY_UP ||
      key === KEY_DOWN ||
      key === KEY_PAGE_DOWN ||
      key === KEY_PAGE_UP ||
      key === KEY_PAGE_HOME ||
      key === KEY_PAGE_END;

      if (isNavigationKey) {
        // this stops the grid from receiving the event and executing keyboard navigation
        event.stopPropagation();
      }
    }
  },
});
</script>
<style lang="scss">
.ag-cell-inline-editing {

  .p-datepicker {
    width: 100%;
    height: 100%;

    .p-inputtext {
      border: 0;
      color: inherit;
      padding-top: 0;
      padding-bottom: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
